import React, { useState } from "react";
import localeText from "../../../locale";

const ConfimeaFAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqItems = [
    {
      questionKey: "faq1Question",
      answerKey: "faq1Answer",
    },
    {
      questionKey: "faq2Question",
      answerKey: "faq2Answer",
    },
    {
      questionKey: "faq3Question",
      answerKey: "faq3Answer",
    },
    {
      questionKey: "faq4Question",
      answerKey: "faq4Answer",
    },
    {
      questionKey: "faq5Question",
      answerKey: "faq5Answer",
    },
  ];

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <section id="faq" className="confimea-faq-section">
      <div className="confimea-container">
        <div className="confimea-section-header flex flex-column gap-4">
          <div>
            <span className="confimea-section-badge">{localeText("faqBadge")}</span>
          </div>

          <div className="confimea-section-title">{localeText("faqTitle")}</div>
          <p className="confimea-section-subtitle">{localeText("faqSubtitle")}</p>
        </div>

        <div className="confimea-faq-list">
          {faqItems.map((item, index) => (
            <div key={index} className={`confimea-faq-item ${openIndex === index ? "open" : ""}`}>
              <button className="confimea-faq-question" onClick={() => toggleFaq(index)}>
                {localeText(item.questionKey)}
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M6 9l6 6 6-6" />
                </svg>
              </button>
              <div className="confimea-faq-answer">{localeText(item.answerKey)}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ConfimeaFAQ;
